module.exports = ":host, google-map {\n  display: block;\n  width: inherit;\n  height: inherit; }\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/branch/branch.component.scss
// module id = ./client/app/branch/branch.component.scss
// module chunks = main